<template>
  <table class="table table-hover rounded overflow-hidden shadow-sm mb-0">
    <TableHeader
      :columns="colsNames"
      :sort-direction="sortDirection"
      :sort-key="sortKey"
      :sortable="sortable"
      @sort="sort"
    />
    <tbody>
      <template v-if="props.loading === true">
        <TableRow v-for="item in placeholderNum(5, 9)" :key="item" style="border-style: none">
          <td v-for="col in colsNames" :key="col" class="placeholder-glow">
            <span class="placeholder w-100"></span>
          </td>
        </TableRow>
      </template>
      <slot
        v-if="props.loading === false && sortedRows.length > 0 && colsNames.length > 0"
        name="row"
        :sorted-rows="sortedRows"
      />
      <tr v-else-if="props.loading === false">
        <td colspan="999">
          <span class="d-flex justify-content-center">No data found</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script setup lang="ts" generic="T extends {[key: string]: any}">
interface Props {
  rows?: T[];
  loading?: boolean;
  colsMap?: {[key: string]: string};
  sortMap?: {key: string; direction: number};
  sortable?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  rows: () => [],
  loading: false,
  colsMap: () => ({}),
  sortMap: () => ({key: '', direction: 1}),
  sortable: true,
});

const emits = defineEmits(['sort']);

const {placeholderNum} = usePlaceholderNum();

const colsNames = computed<string[]>(() => Object.keys(props.colsMap) || []);
const sortKey = ref(props.sortMap.key);
const sortDirection = ref(props.sortMap.direction);

const sortedRows = computed(() => {
  return sortKey.value !== undefined
    ? props.rows.slice().sort((a, b) => {
        const sortValue = sortKey.value !== undefined ? props.colsMap[sortKey.value] : '';
        let valueA = a[sortValue];
        let valueB = b[sortValue];

        return typeof valueA === 'string'
          ? valueA.localeCompare(valueB) * sortDirection.value
          : (valueA - valueB) * sortDirection.value;
      })
    : props.rows;
});

const sort = (column: string) => {
  if (sortKey.value === column) {
    sortDirection.value *= -1;
    emits('sort', {key: column, direction: sortDirection.value});
  } else {
    sortKey.value = column;
    sortDirection.value = 1;
    emits('sort', {key: column, direction: sortDirection.value});
  }
};
</script>
